export default __webpack_public_path__ + "static/media/gallery-wip-pommel_02.d3de9c28.jpg";